module.exports = __webpack_public_path__ + "img/symbol-all-download.6482afdc.svg";